@if (data(); as msg) {
    Added  <department-item [department]="msg.department" />
}
 